import React from "react";
import { Breadcrumb } from "react-bootstrap";
import MasterLayout from "../../masterLayout/MasterLayout";
import ContentLayer from "./ContentLayer";

const ContentPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Components / Content" />
      <ContentLayer />
    </MasterLayout>
  );
};

export default ContentPage;
